import addClass from '../../scripts/util/DOM/addClass';

const selectors = {
	body: 'body',
	state: 'is-retina'
};

const isRetina = () => {
	if (window.matchMedia) {
		const mq = window.matchMedia('only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)');
		return (mq && mq.matches || (window.devicePixelRatio > 1));
	}
};

const render = () => {

	const isRetinaTest = isRetina();

	if (isRetinaTest) {
		addClass(selectors.state)(document.querySelector(selectors.body));
	}
};

export default render;

